<template>
    <div>
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 justify-content-center align-self-center pb-2">
                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                            <li class="text-white"><a href="#">Home</a></li>
                            <li class="text-white"><a href="#">Pages</a></li>
                            <li class="text-white active">Login</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Breadcrumb End -->
        <!-- Start Login -->
        <section class="section">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-6">
                        <form class="contact_form mt-3 common_form pt-3">
                            <div>
                                <h1 class="font-weight-bold text-center">Login</h1>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class="login-icon mdi mdi-account"></i>
                                        <input name="username" id="username" type="text" class="form-control" placeholder="User name...">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class="login-icon mdi mdi-lock"></i>
                                        <input name="password" id="password" type="password" class="form-control" placeholder="Password...">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="rememberme">
                                            <label class="custom-control-label text-2" for="rememberme">Remember Me</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group text-sm-right">
                                        <a href="#" class="text-body">Lost Password ?</a>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 text-center">
                                    <input type="submit" class="btn btn-gradient text-white w-100 text-uppercase" value="Log In">
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Login -->
    </div>
</template>
<script>
    export default {
        name: "login",
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.hidePreloader();
            },

            /*----PRELOADER-----*/
            hidePreloader() {
                var preloaderFadeOutTime = 500;
                var preloader = $('.spinner-wrapper');
                setTimeout(function () {
                    preloader.fadeOut(preloaderFadeOutTime);
                }, 500);
            }

        }
    }</script>
